import { render, staticRenderFns } from "./SupperFatMale.vue?vue&type=template&id=1f58ef01&scoped=true&"
import script from "./SupperFatMale.vue?vue&type=script&lang=js&"
export * from "./SupperFatMale.vue?vue&type=script&lang=js&"
import style0 from "./SupperFatMale.vue?vue&type=style&index=0&id=1f58ef01&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f58ef01",
  null
  
)

export default component.exports